<template>
  <div class="sidebar-collapse-card-item">
    <b-btn
      @click="toggle"
      class="sidebar-collapse-btn"
      :class="{
            collapsed: expanded,
            'bg-danger': red
          }"
      aria-controls="collapse1"
      :aria-expanded="expanded ? 'true' : 'false'"
    >
      <i class="fas fa-map-marker-alt"></i>
      {{ name }}
      <i v-if="loading" class="fas fa-spinner fa-spin"></i>
      <span class="sidebar-collapse-btn--toggle-text"></span>
    </b-btn>
    <template v-for="(item, mainIndex) in wojewodztwa">
      <b-collapse id="collapse1" :key="mainIndex" class="with-province" :visible="expanded">
        <b-card class="sidebar-collapse-body">
          <div
            class="sidebar-menu-name"
            :class="'sidebar-menu-name-' + mainIndex"
          >{{ item.nazwa | capitalize }}</div>
          <div
            :id="`list-jst-${listType}-district-${district.id}`"
            class="sidebar-collapse-sub"
            v-for="(district, index) in item.powiaty.filter(powiatFilter)"
            :key="index"
          >
            <b-btn
              @click="togglePowiat(listType, district)"
              class="sidebar-collapse-sub-btn"
              :aria-controls="'collapse' + mainIndex+index"
              variant="link"
            >
              {{ $t("nav.district") }} {{ district.nazwa | capitalize }}
              <b-badge>{{ district.gminy.filter(gminaFilter).length }}</b-badge>
            </b-btn>
            <b-collapse
              :id="'collapse' + mainIndex+index"
              :visible="powiatExpanded(listType, district)"
            >
              <b-card>
                <template
                  v-for="(community, subIndex) in district.gminy.filter(g => gminaFilter(g))"
                >
                  <b-btn
                    :id="`list-jst-${listType}-community-${community.id}`"
                    @click="toggleGmina(listType, community)"
                    class="sidebar-collapse-sub-sub-btn"
                    :aria-controls="'collapse' + mainIndex+index+subIndex"
                    :key="subIndex"
                    variant="link"
                  >
                    {{ $t("nav.infoPanel.community") }}
                    {{ community.nazwa | removeCommunityName }}
                    <b-badge>{{ gminaBadge(community) }}</b-badge>
                  </b-btn>
                  <b-collapse
                    :id="'collapse' + mainIndex+index+subIndex"
                    :key="'0'+subIndex"
                    :visible="gminaExpanded(listType, community)"
                  >
                    <b-card>
                      <slot v-bind:gmina="community"></slot>
                    </b-card>
                  </b-collapse>
                </template>
              </b-card>
            </b-collapse>
          </div>
        </b-card>
      </b-collapse>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    listType: String,
    loading: Boolean,
    gminaFilter: Function,
    gminaBadge: Function,
    red: Boolean
  },
  computed: {
    expanded() {
      return this.$store.getters.listExpanded(this.listType);
    },
    wojewodztwa() {
      return this.$store.state.jst.wojewodztwa.filter(w => {
        return w.powiaty.some(i => this.powiatFilter(i));
      });
    },
    powiatExpanded() {
      return this.$store.getters.powiatExpanded;
    },
    gminaExpanded() {
      return this.$store.getters.gminaExpanded;
    },

    currlang() {
      return this.$parent.currlang;
    }
  },
  methods: {
    powiatFilter(powiat) {
      return powiat.gminy.some(i => this.gminaFilter(i));
    },
    toggle() {
      this.$store.dispatch("toggleList", { listType: this.listType });
    },
    togglePowiat(listType, powiat) {
      this.$store.dispatch("togglePowiat", { listType, powiat });
    },
    toggleGmina(listType, gmina) {
      this.$store.dispatch("toggleGmina", { listType, gmina });
    }
  }
};
</script>
